import { render, staticRenderFns } from "./EspecialidadeTabela.vue?vue&type=template&id=32e7ed5e"
import script from "./EspecialidadeTabela.vue?vue&type=script&lang=js"
export * from "./EspecialidadeTabela.vue?vue&type=script&lang=js"
import style0 from "./EspecialidadeTabela.vue?vue&type=style&index=0&id=32e7ed5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports